var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget"},[(_vm.header)?_c('header',[_vm._t("cover"),_vm._v(" "),_c('div',{class:{ container: _vm.container, 'no-margin': _vm.noMargin }},[_c('div',{staticClass:"mt-dropdown"},[_vm._t("overflow")],2),_vm._v(" "),_c('h2',{staticClass:"mt-title"},[_vm._t("heading")],2)])],2):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }